var exports = {
  "k": "x93eb46d8--457171--container",
};

module.exports = exports;
